module.exports = __webpack_public_path__ + "static/media/batteryIcon.03b7cf7e.svg";